import React, { Component } from 'react'
import avatarUrl from '../images/avatar_2.png'
import { connect } from 'react-redux'
import Ink from 'react-ink'
import PropTypes from 'prop-types'

class UserSelector extends Component {
  constructor(props) {
    super(props)
    this.handleTouchTap = this.handleTouchTap.bind(this);
  }

  handleTouchTap() {
    this.props.onClick(this.props);
  }

  render() {
    let style = {
      backgroundColor: 'transparent',
      bottom: `${this.props.Bottom * 50}%`
    };
    if (this.props.Selected) {
      style = {
        backgroundColor: 'rgba(51,144,180, 0.7)',
        bottom: `${this.props.Bottom * 50}%`
      }
    }

    return (
        <button className="userselector" style={style} onClick={this.handleTouchTap}>
           <img src={avatarUrl} alt="Avatar" />
           <div>{this.props.UserName}</div>
          <Ink />
        </button>
      )
  }
}
UserSelector.propTypes = {
  UserName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  Selected: PropTypes.bool,
  Bottom: PropTypes.number.isRequired
}
function mapStateToProps() {
  return {

  }
}

export default connect(mapStateToProps)(UserSelector);



// WEBPACK FOOTER //
// src/login/UserSelector.jsx